import { recentMessages } from "@/data/chat-data";
import { Avatar, AvatarFallback, AvatarImage } from "@radix-ui/react-avatar";
import { MessageSquare, X } from "lucide-react";
import Link from "next/link";
import { Button } from "../ui/button";
type Props = {
  isMessagesDrawerOpen: boolean;
  setIsMessagesDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleMessageClick: (conversationId: string) => void;
};

const ChatDrawer = ({ setIsMessagesDrawerOpen, isMessagesDrawerOpen, handleMessageClick }: Props) => {
  return (
    <div
      className={`fixed top-0 right-0 z-50 flex h-full w-full flex-col bg-background shadow-xl transition-transform duration-300 ease-in-out sm:w-96 ${isMessagesDrawerOpen ? "translate-x-0" : "translate-x-full"}`}
    >
      <div className="flex items-center justify-between p-4 border-b">
        <h2 className="text-lg font-semibold">Tin nhắn</h2>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" asChild>
            <Link href="/chat" onClick={() => setIsMessagesDrawerOpen(false)}>
              Mở chat
            </Link>
          </Button>
          <Button variant="ghost" size="icon" onClick={() => setIsMessagesDrawerOpen(false)} aria-label="Close messages">
            <X className="h-5 w-5" />
          </Button>
        </div>
      </div>

      <div className="flex flex-1 flex-col overflow-y-auto p-2">
        {recentMessages.length === 0 ? (
          <div className="flex flex-col items-center justify-center px-6 py-14 text-center text-muted-foreground">
            <MessageSquare className="mb-3 h-12 w-12 opacity-50" aria-hidden />
            <p className="font-medium text-foreground">Chưa có tin nhắn</p>
            <p className="mt-2 text-sm">Chat nội bộ sẽ hiển thị tại đây sau khi tính năng được bật.</p>
          </div>
        ) : (
          recentMessages.map((message) => (
            <div
              key={message.id}
              className="flex cursor-pointer items-start gap-3 rounded-lg p-3 transition-colors hover:bg-muted"
              role="button"
              tabIndex={0}
              onClick={() => handleMessageClick(message.conversationId)}
              onKeyDown={(e) => e.key === "Enter" && handleMessageClick(message.conversationId)}
            >
              <div className="relative">
                <Avatar className="size-10">
                  <AvatarImage className="size-10 rounded-full object-cover object-center" src={message.avatar || "/placeholder.svg"} alt={message.sender} />
                  <AvatarFallback>{message.sender.charAt(0)}</AvatarFallback>
                </Avatar>
                {message.unread && <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full border-2 border-background bg-primary" />}
              </div>
              <div className="min-w-0 flex-1 space-y-1 overflow-hidden">
                <div className="flex items-center justify-between">
                  <p className={`font-medium ${message.unread ? "text-foreground" : "text-muted-foreground"}`}>{message.sender}</p>
                  <span className="text-xs text-muted-foreground">{message.time}</span>
                </div>
                <p className={`truncate text-sm ${message.unread ? "text-foreground" : "text-muted-foreground"}`}>{message.content}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ChatDrawer;
